module.exports = __webpack_public_path__ + "5838f23e7576194a62476716d721198a.svg";